import { render, staticRenderFns } from "./sns_m.vue?vue&type=template&id=90f4f1ce&"
import script from "./sns_m.vue?vue&type=script&lang=ts&"
export * from "./sns_m.vue?vue&type=script&lang=ts&"
import style0 from "./sns_m.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports